import { ExternalLink } from "lucide-react";

/** Build the Airbnb listing URL, passing dates / guests along when we have them (Airbnb reads these params). */
export function airbnbHref(baseUrl, { checkIn, checkOut, adults, children, infants, pets } = {}) {
  if (!baseUrl) return "";
  try {
    const u = new URL(baseUrl);
    if (checkIn && checkOut) { u.searchParams.set("check_in", checkIn); u.searchParams.set("check_out", checkOut); }
    if (adults) u.searchParams.set("adults", String(adults));
    if (children) u.searchParams.set("children", String(children));
    if (infants) u.searchParams.set("infants", String(infants));
    if (pets) u.searchParams.set("pets", String(pets));
    return u.toString();
  } catch {
    return baseUrl;
  }
}

/**
 * "Book on Airbnb" link. A normal https link: on phones with the Airbnb app installed it opens the listing
 * in the app (universal / app links), otherwise the Airbnb website. Renders nothing until a URL is configured.
 */
export default function AirbnbLink({ url, stay, className = "btn-ghost", children, testid = "airbnb-link" }) {
  const href = airbnbHref(url, stay);
  if (!href) return null;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center justify-center gap-2 ${className}`} data-testid={testid}>
      {children || "Book on Airbnb"} <ExternalLink size={14} aria-hidden="true" />
    </a>
  );
}
